
import { pp, pp_user, app_state, reverseDate, dateNow/* , formatDate, rolesToString */ } from '@helpers'

export {
    getRealUser,
    getUser,
    getUsersByShopId,
    findShopIdOfClient,
    userHasEmptyParam,
    hasRole,
}

const getRealUser = ()=>{
    if(pp().member_getted){
        return pp().member_getted
    } else {
        return pp_user()
    }
}

const getUser = (user_id = null)=>{
    if( ! user_id){ user_id = pp().user.id }
    return _.find(app_state().all_users, {value: user_id}) ?? {}
}

const getUsersByShopId = (shop_id, without_free_contact = false)=>
{
    // if( ! user_id){ user_id = pp().user.id }
    // return _.find(app_state().all_users, {shop_id: shop_id/* , value: user_id */}) ?? {}

    // let list = _.filter(app_state().all_users, {shop_id: shop_id}) ?? _.filter(app_state().all_users, u => u.shop_id)
    let list = _.filter(app_state().all_users, u=> _.includes(u.shops_id, shop_id))

    if( ! without_free_contact){
        list.push({value: false, label: 'Contact Libre'})
    }
    list.unshift({value: null, label: 'Aucun'})

    return list
}

const findShopIdOfClient = (user_id = null)=>{
    if( ! user_id){ user_id = pp().user.id }
// log('in findShopIdOfClient()',user_id, app_state().all_users)

    // return _.find(app_state().all_users, {value: user_id})?.shop_id || null
    return _.head(_.find(app_state().all_users, {value: user_id})?.shops_id) || null
}


/**
 * @return Number count of defaults
 */
const userHasEmptyParam = (user = null)=>{
    var count = 0

    if( ! user){ user = pp_user() }
// log(pp().isMember, user)

    if(! user.email)        count++
    // if(! user.phone)        count++
    // if(! user.birthday)     count++
    // if(! user.infos?.rue)   count++
    // if(! user.infos?.cp)    count++
    // if(! user.infos?.ville) count++
    // if(! user.infos?.pays)  count++

    if(hasRole(user.roles, 'client')){
        // if(! user.address)  count++
        if(! user.shop)  count++
    }


// log('in userHasEmptyParam()', count)

    if(! user.password_modified)   count++

    return count
}

/**
 * get if user has role
 * @param Mix       user_roles      (roles of user)  string: xxx|yyy  OR  array: [xxx, yyy]  OR  object: [{name: xxx},{name: yyy}]
 * @param Mix       roles           (ex: admin|driver)  string: xxx|yyy  OR  array: [xxx, yyy]  OR  object: [{name: xxx},{name: yyy}]
 * @param String    by              name|id
 * @returns {Boolean}
*/
const hasRole = (user_roles, roles, by = 'name')=>{

    if(_.isEmpty(user_roles)){return false}

// log('1 in hasRole()', user_roles, roles)

    if(_.isArray(user_roles)){
        if(_.isObject(user_roles[0])){
            user_roles = _.map(user_roles, by)
        }
    }
    else if(_.isString(user_roles)){
        user_roles = user_roles.split('|')
    }

    if(_.isArray(roles)){
        if(_.isObject(roles[0])){
            roles = _.map(roles, by)
        }
    }
    else if(_.isString(roles)){
        roles = roles.split('|')
    }

// log('2 in hasRole()', user_roles, roles)


// var regexp = new RegExp(roles)
    // if(regexp.test(user_roles)){

    if(_.size(_.intersection(roles, user_roles))){
        return true
    }

    // if(proto.user && proto.$_user.roles && proto.$_user.roles.length){
    // 	// var user_roles_name_arr = this.$_objToArr(proto.$_user.roles).map(opt => (opt[1].name) );
    // 	var user_roles_name_arr = this.$_objToArr(proto.$_user.roles).map(opt => (opt[1].name) );

    // 	if(typeof roles !== 'string'){
    // 		return _.intersection(user_roles_name_arr, roles).length ? true : false;
    // 	} else {
    // 		return _.intersection(user_roles_name_arr, [roles]).length ? true : false;
    // 	}
    // }
    return false;
}
